import React from "react";

import StdButton from './stdbutton.jsx';
import UserContext from './usercontext.jsx';
import Grid from '@mui/material/Grid';
import SvgIcon from '@mui/material/SvgIcon';

class Header extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            error: null,
            isDone: false,
            resetRequested: false
        };

        this.setState = this.setState.bind(this);
        this.doReset = this.doReset.bind(this);
        this.renderAlert = this.renderAlert.bind(this);
    }

    doReset(){
       this.setState({ resetRequested: true  });
        doPost("/web/reset", {}, this.setState);
    }

    render() {
        return (
            <UserContext.Consumer>
                {user => (
                    <Grid container spacing={0} style={{ backgroundColor: '#ffffff', borderBottom: '2px solid #dfdfdf', position: 'fixed', top: 0, height: 90, zIndex: 100 }}>
                        <Grid item xs={4} sm={4} style={{ padding: 10 }}>
                            <img src="/img/img_logo_app_bar.svg"/>
                        </Grid>
                        <Grid item xs={5} sm={5} style={{ paddingLeft: 5, paddingRight: 5, paddingTop: 15, verticalAlign: 'middle' }}>
                            {this.renderAlert(user)}
                        </Grid>
                        <Grid item xs={3} sm={3} style={{ padding: 30, textAlign: 'right' }}>
                            { user.auth && (
                                <h6 className="loggedAsHolder">
                                    <SvgIcon>
                                        <path fill="none" d="M0 0h24v24H0V0z"/><path d="M12 6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2m0 10c2.7 0 5.8 1.29 6 2H6c.23-.72 3.31-2 6-2m0-12C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 10c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/>
                                    </SvgIcon>
                                    {user.name}
                                </h6>
                            )}
                        </Grid>
                    </Grid>
                )}
            </UserContext.Consumer>
        )
    }

    renderAlert(user){
        if (this.state.error) {
            return (<div className="alert alert-danger" role="alert" style={{ marginBottom: 0, fontSize: '0.9rem' }}>Error: {this.state.error.message}</div>);
        } else {
            if (this.state.isDone) {
                return (<div className="alert alert-success" role="alert" style={{ marginBottom: 0, fontSize: '0.9rem' }}>Please check your mailbox and find password reset link.</div>);
            } else {
                if (this.state.resetRequested) {
                    return (<div className="alert alert-warning" role="alert" style={{ marginBottom: 0, fontSize: '0.9rem' }}><div className="spinner-border m-1" /></div>);
                } else {
                    if (user.daysBeforeExpiry<5) {
                        return (
                            <div className="alert alert-warning" role="alert" style={{ marginBottom: 0, fontSize: '0.9rem' }}>
                                Your password will expire within {Math.round(user.daysBeforeExpiry)} days.
                                <StdButton onClick={this.doReset} label="Reset password"/>
                            </div>
                        )
                    }
                }
            }
        }
    }
}

export default Header;